import { useMemo } from 'react';
import { useTeam } from '@vrplatform/data';
import type { IssueRow } from '@vrplatform/data';

type IssuesData = { aggregate: number; list: IssueRow[] };

export const useTeamIssues = (): IssuesData => {
  const [{ issues }] = useTeam();

  return useMemo<IssuesData>(() => {
    const list = (issues ?? []).reduce<IssueRow[]>((acc, issue) => {
      const isBroken = issue.code === 'brokenConnections';
      const isOutdated = issue.code === 'outdatedConnections';

      if (!isBroken && !isOutdated) return acc;

      const type: IssueRow['type'] = isBroken
        ? 'connection-error'
        : 'connection-version-outdated';

      const message = isOutdated
        ? 'Please reconnect this connection to update the version.'
        : 'Connection error';

      const connections = issue.context?.connections ?? [];

      return connections.reduce<IssueRow[]>((inner, connection) => {
        const id = connection.id;
        const name = connection.name;

        inner.push({
          id,
          type,
          table: 'connection',
          level: 'error',
          message,
          date: null,
          itemName: name,
          item: name,
        });

        return inner;
      }, acc);
    }, []);

    return {
      aggregate: list.length,
      list,
    };
  }, [issues]);
};
